/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
// Media'
import clsx from 'clsx'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {success} from '../../../../Global/toast'
import Password from '../../../../_supplier/assets/media/auth/password.png'
import ShowPassword from '../../../../_supplier/assets/media/auth/showPassword.png'
import BrandLogo from '../../../../_supplier/assets/media/uTrade-logo.png'
import LoginBg from '../../../../_supplier/assets/media/login bg.png'
import APICallService from '../../../../api/apiCallService'
import {AUTH} from '../../../../api/apiEndPoints'
import {AuthJSON} from '../../../../api/apiJSON/auth'
import {auth} from '../../../../utils/toast'
import {useAuth} from '../core/Auth'
import {authCardClassName} from '../AuthLayout'

const loginSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(6, 'Length should be minimum 6')
    .max(15, 'Length should be maximum 15')
    .required('Password is required'),
})

const initialValues = {
  newPassword: '',
}

const CreatePassword = () => {
  const location: any = useLocation()
  const navigate = useNavigate()
  const {saveAuth, saveCurrentUser} = useAuth()
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        if (location.state) {
          let data = {
            ...location.state,
            newPassword: values.newPassword,
          }
          let apiService = new APICallService(AUTH.RESETPASSWORD, AuthJSON.resetPassword(data))
          let response = await apiService.callAPI()
          if (response) {
            saveAuth(response.token)
            let user = response.user

            saveCurrentUser(user)
            success(auth.passwordReset)
          }
        }
      } catch (error) {
        setStatus('The registration details is incorrect')
      }
      setSubmitting(false)
      setLoading(false)
    },
  })
  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid min-vh-100 h-100'>
      <div
        className='d-flex flex-column flex-lg-row-fluid w-lg-50 bg-body px-4 py-6 sm:px-6 sm:py-8 lg:p-25 order-2 overflow-auto min-h-0'
        style={{
          backgroundImage: `url(${LoginBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div
          className='d-flex w-100 justify-content-center justify-content-lg-end align-items-center flex-lg-row-fluid py-2 sm:py-4 lg:py-0'
          style={{paddingRight: '86px'}}
        >
          <form
            className={clsx(authCardClassName, 'form w-100 position-relative')}
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <div className='mb-4 sm:mb-6'>
              <img
                src={BrandLogo}
                alt='logo'
                width={150}
                height={50}
                className='mb-3 mx-auto d-block'
                style={{maxWidth: '70%', height: 'auto'}}
              />
              <h1 className='text-dark text-center fw-700 mb-3 text-[22px] sm:text-[26px] lg:text-[28px]'>
                Create New Password
              </h1>
              <p className='text-center fw-normal text-sm sm:text-base'>
                Please set a new password for your account.
              </p>
            </div>
            <div className='flex flex-col items-center w-full'>
              <div className='fv-row mb-3 w-full flex flex-col items-center'>
                <div
                  style={{
                    display: 'flex',
                    width: '416px',
                    height: '56px',
                    padding: '10px 20px',
                    alignItems: 'center',
                    gap: '10px',
                    borderRadius: '12px',
                    border: '1px solid var(--essentials-border, #E6E6E7)',
                    background: 'var(--white, #FFF)',
                  }}
                >
                  <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder='New Password'
                    autoComplete='off'
                    {...formik.getFieldProps('newPassword')}
                    value={formik.values.newPassword.trimStart()}
                    onChange={(e) => {
                      formik.handleChange(e)
                    }}
                    name='newPassword'
                    style={{flex: 1, minWidth: 0, fontSize: '16px'}}
                  />
                  {showPassword ? (
                    <img
                      height={15}
                      width={25}
                      src={ShowPassword}
                      onClick={() => setShowPassword(!showPassword)}
                      alt=''
                      style={{cursor: 'pointer', flexShrink: 0}}
                    />
                  ) : (
                    <img
                      height={15}
                      width={25}
                      src={Password}
                      onClick={() => {
                        formik.values.newPassword.trimStart()
                          ? setShowPassword(!showPassword)
                          : setShowPassword(false)
                      }}
                      alt=''
                      style={{cursor: 'pointer', flexShrink: 0}}
                    />
                  )}
                </div>
                {formik.touched.newPassword && formik.errors.newPassword && (
                  <div
                    className='fv-plugins-message-container'
                    style={{width: '416px', textAlign: 'start'}}
                  >
                    <span role='alert' className='text-danger fs-14 fw-500'>
                      {formik.errors.newPassword}
                    </span>
                  </div>
                )}
              </div>
              <div className='w-full flex justify-center mt-4'>
                <button
                  type='submit'
                  id='kt_sign_in_submit'
                  className={clsx('form-control form-control-custom text-center border-0')}
                  style={{
                    display: 'flex',
                    width: '416px',
                    height: '56px',
                    padding: '10px 20px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px',
                    background: '#1B74E4',
                    borderRadius: '12px',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#fff',
                    opacity: !formik.values.newPassword.trimStart() || loading ? 0.5 : 1,
                    cursor: !formik.values.newPassword.trimStart() || loading ? 'not-allowed' : 'pointer',
                  }}
                  disabled={!formik.values.newPassword.trimStart() || loading}
                >
                  {loading ? (
                    <span className='indicator-progress indicator-label fs-16 fw-600'>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    <span className='indicator-label fs-16 fw-bolder'>Set Password & Sign in</span>
                  )}
                </button>
              </div>
            </div>
            <div className='w-full text-center mt-4 sm:mt-5'>
              <Link
                to='/auth/login'
                className='text-center text-sm sm:text-[16px] font-bold text-[#1B74E4] underline decoration-[1.2px] underline-offset-[2.88px]'
              >
                Go back to Sign in
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
export {CreatePassword}
